import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const WhirlArrowIcon = () => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={78}
      height={78}
      viewBox="0 0 78 78"
      fill="none"
    >
      <g
        clipPath="url(#a)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#FFF1C6"
      >
        <path d="M47.316 40.011c1.54.073 2.984.702 4.197 2.066 3.754 4.22 3.345 9.04.905 13.543C48.855 62.196 40.9 68.079 35.71 70.236a.47.47 0 0 1-.62-.26.49.49 0 0 1 .267-.631c5.038-2.094 12.765-7.796 16.223-14.178 2.24-4.135 2.664-8.565-.784-12.44-1.026-1.153-2.246-1.68-3.548-1.745q-.103 1.288-.276 2.533c-.32 2.292-2.225 8.026-4.943 11.426-1.95 2.44-4.316 3.678-6.799 2.046-1.38-.907-1.844-2.426-1.589-4.227.35-2.476 2.1-5.518 4.47-8.003 1.974-2.07 4.372-3.752 6.714-4.426a8.4 8.4 0 0 1 1.533-.296c.731-11.911-3.015-25.792-9.993-34.988a.49.49 0 0 1 .094-.677.473.473 0 0 1 .67.083c7.09 9.346 10.91 23.44 10.187 35.558m-1.029 1.003q-.1 1.209-.263 2.382c-.307 2.196-2.132 7.688-4.737 10.947-1.598 2-3.49 3.171-5.526 1.833-1.068-.703-1.37-1.9-1.173-3.295.217-1.534 1.026-3.293 2.19-4.982 1.765-2.565 4.35-4.967 6.998-6.16.84-.377 1.685-.632 2.511-.725" />
        <path d="M35.254 23.018c2.184-5.35 2.266-12.437 1.124-18.087a.49.49 0 0 1 .374-.574.47.47 0 0 1 .564.367c1.179 5.826 1.074 13.132-1.178 18.648a.484.484 0 0 1-.625.27.477.477 0 0 1-.26-.624" />
        <path d="M37.42 4.669c2.236 4.191 7.42 7.788 11.96 9.177a.475.475 0 0 1 .311.6.484.484 0 0 1-.6.323c-4.758-1.455-10.172-5.242-12.515-9.633a.49.49 0 0 1 .197-.656.47.47 0 0 1 .648.189" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M77.617 29.474 30 0 0 48.467 47.616 77.94z" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { WhirlArrowIcon };
